import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { AuthState } from './types';
import {
  doGetUserProfile,
  doLoginRequest,
  doRegistrationRequest,
} from './userAPI';

import { clearAuthToken, getAuthToken, setAuthToken } from '../../utils';

// User Profile
export const getUserProfile = createAsyncThunk(
  'auth/getUserProfile',
  async () => {
    return await doGetUserProfile();
  },
);

// Login Process
export const doLogin = createAsyncThunk(
  'auth/login',
  async ({ username, password }: { username: string; password: string }) => {
    return await doLoginRequest(username, password);
  },
);

// Registration Process
export const doRegistration = createAsyncThunk(
  'auth/registration',
  async ({
    username,
    email,
    password,
    pin,
  }: {
    username: string;
    email: string;
    password: string;
    pin: string;
  }) => {
    return await doRegistrationRequest(username, email, password, pin);
  },
);

const initialState: AuthState = {
  isLoading: false,
  login: {
    username: '',
    password: '',
  },
  session: {
    recoveringSession: true,
    logged: false,
    access_token: '',
  },
  profile: null,
};

export const captureSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    // Realod Login from LocalStorage
    initializeLogin: (state) => {
      const token = getAuthToken();
      if (token) {
        state.session.access_token = token;
        state.session.logged = true;
      }
      state.session.recoveringSession = false;
    },
    doLogout: (state) => {
      state.login = initialState.login;
      state.profile = initialState.profile;
      state.session = initialState.session;
      clearAuthToken();
    },
    // Login
    setUsername: (state, action: PayloadAction<string>) => {
      state.login.username = action.payload;
    },
    setPassword: (state, action: PayloadAction<string>) => {
      state.login.password = action.payload;
    },
  },
  extraReducers: (builder) => {
    // Sucessfull login attempt
    builder.addCase(doLogin.fulfilled, (state, { payload }) => {
      state.session.access_token = payload.access_token;
      state.session.logged = true;
      setAuthToken(payload.access_token);
    });

    // User Registered
    builder.addCase(doRegistration.fulfilled, (state, { payload }) => {
      // Empty Case...
    });

    // Get user Profile
    builder.addCase(getUserProfile.fulfilled, (state, { payload }) => {
      state.profile = payload;
    });
  },
});

export const {
  setLoading,
  // Realod Session
  initializeLogin,
  doLogout,
  // Login
  setUsername,
  setPassword,
} = captureSlice.actions;

export default captureSlice.reducer;
